import {
	ReactElement,
	useCallback,
	useState
} from "react";
import { WelcomeStep } from "./WelcomeStep/WelcomeStep";
import { localize } from "client_legacy/ndaw/culture";
import { BusyIndicator } from "client/Components";
import { navigateRelativeToEnvironment } from "client_legacy/ndaw/navigator";
import image from "Content/Images/404-error.svg";
import { ContentLayout } from "./ContentLayout";

export type ForcedSignOutStepProps = {
	reason: ForcedSignoutReason;
};

export const ForcedSignOutStep = (props: ForcedSignOutStepProps): ReactElement => {
	const { reason } = props;

	const [isBusy, setIsBusy] = useState<boolean>(false);

	const signoutHandler = useCallback(
		(): void => {
			setIsBusy(true);
			navigateRelativeToEnvironment("SignOut");
		},
		[]
	);

	const configuration: StepConfiguration = reasonToConfigurationMap[reason];

	return (
		<WelcomeStep>
			<WelcomeStep.Left
				trackingId="sign-out-step"
				isVerticallyCentred
			>
				{isBusy && (
					<BusyIndicator />
				)}

				<ContentLayout
					title={localize(configuration.title)}
					explanation={localize(configuration.explanation)}
				>

					<ContentLayout.Buttons
						onContinue={signoutHandler}
						primaryButtonText={localize("_SignOut")}
					/>
				</ContentLayout>
			</WelcomeStep.Left>

			<WelcomeStep.Right
				imageUrl={configuration.imageUrl}
			/>
		</WelcomeStep>
	);
};
ForcedSignOutStep.displayName = "ForcedSignOutStep";

type ForcedSignoutReason = "blocked" | "password-expired";

type StepConfiguration = {
	title: LocalizationKey;
	explanation: LocalizationKey;
	imageUrl: string;
};

const reasonToConfigurationMap: Record<ForcedSignoutReason, StepConfiguration> = {
	["blocked"]: {
		title: "_Office365AccountIsBlockedDialogTitle",
		explanation: "_Office365AccountIsBlockedDialogMessage",
		imageUrl: image
	},
	"password-expired": {
		title: "_Office365PasswordHasExpiredDialogTitle",
		explanation: "_Office365PasswordHasExpiredDialogMessage",
		imageUrl: image
	}
};
